<template>
  <BaseButton
    color="outline-secondary"
    class="tw-mx-2 tw-mb-2 tw-grow lg:tw-m-0"
    @click="findOrCreateConversation"
    :is-disabled="isLoading || isDisabled"
    :class="{ '!tw-cursor-wait': isLoading }"
  >
    <MessagesIcon class="tw-mr-2 tw-h-4 tw-w-4" />
    Message me
  </BaseButton>
</template>

<script setup>
import BaseButton from '@/shared/components/BaseButton.vue'
import MessagesIcon from '@/assets/images/icons/messages.svg'
import { ACCESS_TYPE, ROLE } from '@/shared/data/permissionSystem.js'
import { ref } from 'vue'
import { usePermissionSystem } from '@/shared/composables/usePermissionSystem.js'
import axios from 'axios'
import { useModals } from '@/shared/composables/useModals.js'
import { UNLOCK_FULL_ACCESS_MODAL_NAME } from '@/shared/data/globalVariables.js'
import { router } from '@inertiajs/vue3'

const props = defineProps({
  mentorId: {
    type: Number,
    required: true,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
})

const { hasRole, hasAccess } = usePermissionSystem()
const { openModal } = useModals()

const isLoading = ref(false)

const findOrCreateConversation = async () => {
  if (hasRole(ROLE.GUEST)) {
    return openModal(UNLOCK_FULL_ACCESS_MODAL_NAME)
  }

  if (hasAccess(ACCESS_TYPE.NONE)) {
    return router.visit('/upgrade_plan/new')
  }

  isLoading.value = true
  try {
    const { data } = await axios.post('/conversations', {
      conversation: { receiver_id: props.mentorId },
    })
    router.visit(data)
  } catch (error) {
    console.error(error)
  } finally {
    isLoading.value = false
  }
}
</script>
